module.exports = {
    login: {
        en: "Login",
        fi: "Kirjaudu sisään"
    },
    emailPlaceholder: {
        en: "Email",
        fi: "Sähköposti"
    },
    passwordPlaceholder: {
        en: "Password",
        fi: "Salasana"
    },
    forgotPassword: {
        en: "Forgot password",
        fi: "Unohditko salasanasi?"
    },
    register: {
        en: "Register",
        fi: "Rekisteröidy"
    },
    name: {
        en: "Name",
        fi: "Nimi"
    },
    nameToolTip: {
        en: "Name is required",
        fi: "Nimi on pakollinen"
    },
    email: {
        en: "Email",
        fi: "Sähköposti"
    },
    emailToolTip: {
        en: "Email is required",
        fi: "Sähköposti on pakollinen"
    },
    selectARole: {
        en: "Select a role",
        fi: "Valitse rooli"
    },
    individual: {
        en: "Individual",
        fi: "Yksilö"
    },
    store: {
        en: "Store",
        fi: "Yritys"
    },
    selectARoleToolTip: {
        en: "Role is required",
        fi: "Rooli on pakollinen"
    },
    phone: {
        en: "Phone",
        fi: "Puhelin"
    },
    phoneToolTip: {
        en: "Phone is required",
        fi: "Puhelinnumero on pakollinen"
    },
    selectAProvince: {
        en: "Selected province",
        fi: "Valittu maakunta"
    },
    selectAProvinceToolTip: {
        en: "Province is required",
        fi: "Maakunta on pakollinen"
    },
    selectACity: {
        en: "Select a city",
        fi: "Valitse kaupunki"
    },
    selectACityToolTip: {
        en: "City is required",
        fi: "Kaupunki on pakollinen"
    },
    address: {
        en: "Address",
        fi: "Osoite"
    },
    addressToolTip: {
        en: "Address is required",
        fi: "Osoite on pakollinen"
    },
    website: {
        en: "Website: http://.....",
        fi: "Kotisivu: http://....."
    },
    websiteToolTip: {
        en: "Website is optional",
        fi: "Kotisivu on valinnainen"
    },
    password: {
        en: "Password",
        fi: "Salasana"
    },
    passwordToolTip: {
        en: "Password is required and must be greater than 7 characters",
        fi: "Salasana on pakollinen ja sen tulee olla yli 7 merkkiä pitkä"
    },
    confirmPassword: {
        en: "Confirm password",
        fi: "Vahvista salasana"
    },
    confirmPasswordToolTip: {
        en: "Confirm password is required and must match above password",
        fi: "Salasanan on pakko vastata yllä olevaa"
    },
    addMoreContacts: {
        en: "Add more contacts",
        fi: "Lisää yhteystieto"
    },
    selectLanguages: {
        en: "Select languages",
        fi: "Valitse kieli"
    },
    userImage: {
        en: "Profile image",
        fi: "Profiilikuva"
    },
    userImageToolTip: {
        en: "Image is optional",
        fi: "Kuva on valinnainen"
    },
    submit: {
        en: "Submit",
        fi: "Lähetä"
    }
}